$(window).on('load', function(){

var sc = new ServiceContainer({

    "dispatcher": {
        "className": "EventDispatcher",
        "properties": {
            "debug": "%debug%"
        }
    },
    
    "routing": {
        "className": "Routing",
        "arguments": ["@dispatcher"]
    },
    
    "i18n": {
        "className": "I18N",
        "properties": {
            "debug": "%debug%",
            "lang": "%default_lang%",
            "supportedLangs": ["hu", "en"]
        },
        "calls": [
            ["setDispatcher", ["@dispatcher"]],
            ["loadExtensions", ["@container"]]
        ]
    },
    
    "i18n.strings": {
        "className": "I18N_Strings",
        "arguments": ["@i18n"],
        "tags": ["i18n.extension"]
    },
    
    "templating": {
        "className": "Templating",
        "arguments": ["@nunjucks"],
        "calls": [
            ["loadNunjucksPlugins", ["@container"]]
        ]
    },
    
    "nunjucks": {
        "factory": "nunjucks.configure",
        "arguments": ["views", { "autoescape": true }]
    },
    
    "nunjucks.dateTypes": {
        "className": "nunjucks_global_dateTypes",
        "arguments": ["@catalog_utils"],
        "tags": ["nunjucks.global"]
    },
    
    "nunjucks.topic_colors": {
        "className": "nunjucks_global_topic_colors",
        "tags": ["nunjucks.global"]
    },
    
    "nunjucks.topic_icons": {
        "className": "nunjucks_global_topic_icons",
        "tags": ["nunjucks.global"]
    },
    
    "nunjucks.url": {
        "className": "nunjucks_global_url",
        "arguments": ["@routing", "@i18n"],
        "tags": ["nunjucks.global"]
    },
    
    "nunjucks.numberformat": {
        "className": "nunjucks_global_numberformat",
        "arguments": ["@i18n"],
        "tags": ["nunjucks.global"]
    },
    
    "nunjucks.bl2br": {
        "className": "nunjucks_filter_nl2br",
        "tags": ["nunjucks.filter"]
    },
    
    "nunjucks.trans": {
        "className": "nunjucks_filter_trans",
        "arguments": ["@i18n"],
        "tags": ["nunjucks.filter"]
    },
    
    "nunjucks.transchoice": {
        "className": "nunjucks_filter_transchoice",
        "arguments": ["@i18n"],
        "tags": ["nunjucks.filter"]
    },
    
    "nunjucks.defaults": {
        "className": "nunjucks_filter_defaults",
        "tags": ["nunjucks.filter"]
    },
    
    "nunjucks.date": {
        "className": "nunjucks_filter_date",
        "arguments": ["@dispatcher", "@i18n"],
        "tags": ["nunjucks.filter"]
    },
    
    "view_manager": {
        "className": "ViewManager",
        "arguments": ["@container"],
        "properties": {
            "defaultLang": "%default_lang%"
        }
    },
    
    "view.publications": {
        "className": "PublicationsView",
        "arguments": ["@catalog_utils", "@i18n", "@routing"],
        "tags": ["view"]
    },
    
    "view.first_releases": {
        "className": "FirstReleasesView",
        "arguments": ["@catalog_utils", "@i18n", "@routing"],
        "tags": ["view"]
    },
    
    "view.stadat": {
        "className": "StadatView",
        "arguments": ["@catalog_utils", "@i18n", "@routing"],
        "tags": ["view"]
    },
    
    "view.dissem_db": {
        "className": "DissemDBView",
        "arguments": ["@catalog_utils", "@i18n", "@routing"],
        "tags": ["view"]
    },
    
    "view.custom_content": {
        "className": "CustomContentView",
        "arguments": ["@i18n"],
        "tags": ["view"]
    },
    
    "catalog_utils": {
        "instance": "CatalogUtils",
        "properties": {
            "templating": "@templating"
        },
        "calls": [
            ["ajaxSetup"],
            ["itemAutoLoader_Setup"]
        ]
    },
    
    "google.analytics": {
        "instance": "GoogleAnalytics"
    }

}).setParameters({
    default_lang: 'hu',
    debug: false
});

setTimeout(function(){
    sc.get('view_manager').start(); // itt épül fel a routing tábla is, ez után lehet csak a routingot indítani.
    sc.get('routing').start();
}, 10);

/*
sc.get('routing').addRoute('dummy_route', '/dummy/{routekey}', { routekey: 'default' });
var templating = sc.get('templating');
$('#page').html(templating.render('page.html'));
$('#content').html(templating.render('content.html'));
*/

});
